import { Button, Heading, Text } from "@softmax/design-system";
import { colors, radii, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { accountInitials } from "../initials";

export type AccountPlayer = {
  readonly id: string;
  readonly name: string;
  readonly avatarUrl: string | null;
  readonly isDefault: boolean;
};
export function PlayerIdentity({
  player,
  disabled,
  onRename,
  onMakeDefault,
}: {
  readonly player: AccountPlayer;
  readonly disabled: boolean;
  readonly onRename: () => void;
  readonly onMakeDefault: () => void;
}) {
  return (
    <div {...stylex.props(styles.header)}>
      {player.avatarUrl ? (
        <img alt="" src={player.avatarUrl} {...stylex.props(styles.avatar)} />
      ) : (
        <div aria-hidden="true" {...stylex.props(styles.avatar)}>
          <Text>{accountInitials(player.name)}</Text>
        </div>
      )}
      <div {...stylex.props(styles.title)}>
        <Heading level={3}>{player.name}</Heading>
        {player.isDefault ? (
          <Text size="small" tone="muted">
            Default player
          </Text>
        ) : null}
      </div>
      <div {...stylex.props(styles.actions)}>
        <Button size="sm" onClick={onRename} disabled={disabled}>
          Rename
        </Button>
        {!player.isDefault ? (
          <Button size="sm" onClick={onMakeDefault} disabled={disabled}>
            Make default
          </Button>
        ) : null}
      </div>
    </div>
  );
}
const styles = stylex.create({
  header: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: spacing.space16,
  },
  avatar: {
    width: 64,
    height: 64,
    objectFit: "cover",
    borderRadius: radii.small,
    backgroundColor: colors.surfaceAlt,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  title: { flexGrow: 1, minWidth: 0, overflowWrap: "anywhere" },
  actions: { display: "flex", gap: spacing.space8, flexWrap: "wrap" },
});
